module.exports = __webpack_public_path__ + "img/Step01.343835d0.webp";